/**
 * Lessons registry.
 *
 * Each lesson is one .js file in this directory exporting a module
 * shaped like a masterclass module (key, title, sub, chapters of
 * blocks). Lessons render through the existing MasterclassReader so
 * we don't maintain a parallel reader.
 *
 * To add a new lesson:
 *   1. Create the lesson file (mirror the existing samples)
 *   2. Import it below
 *   3. Add an entry to LESSONS_INDEX with audience + duration estimate
 *
 * That's it. The Insights pages read LESSONS_INDEX to render the
 * rail; clicking a card resolves the moduleKey through LESSON_MODULES
 * and opens the reader.
 *
 * Audience values:
 *   "pd"   — appears in Player Development Insights only
 *   "team" — appears in Team Insights only
 *   "both" — appears on both surfaces
 */

import { QUALITY_SPECIFIC_MOVEMENT_LESSON } from "./qualitySpecificMovement.js";

export const LESSON_MODULES = {
  [QUALITY_SPECIFIC_MOVEMENT_LESSON.key]: QUALITY_SPECIFIC_MOVEMENT_LESSON,
};

export const LESSONS_INDEX = [
  {
    key: QUALITY_SPECIFIC_MOVEMENT_LESSON.key,
    audience: "pd",
    title: QUALITY_SPECIFIC_MOVEMENT_LESSON.title,
    sub: QUALITY_SPECIFIC_MOVEMENT_LESSON.sub,
    duration: "10 min",
    cover: "/images/lesson-quality-specific-movement.svg",
    publishAt: null,
  },
];

// Filter helpers used by the Insights page.
export function lessonsForAudience(audience) {
  const now = Date.now();
  return LESSONS_INDEX.filter(l => {
    if (l.publishAt && new Date(l.publishAt).getTime() > now) return false;
    return l.audience === audience || l.audience === "both";
  });
}
